<template>
  <b-dropdown right variant="link" :menu-class="'dropdown-custom__menu fade'"
              toggle-class="" class="dropdown-custom dropdown-custom--main"
              no-caret>
    <template #button-content>
      <div class="fries">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </template>
    <template v-for="(item, index) in menuItems">
      <router-link :to="{ name: item.route}" tag="b-dropdown-item" :key="index" v-if="item.route">
        <span class="d-flex justify-content-between">
          <span>{{ $t(item.name) }}</span> <span v-if="item.extra" class="extra">{{ item.extra }}</span>
        </span>
      </router-link>
      <b-dropdown-divider v-if="item.divider" :key="index"></b-dropdown-divider>
      <b-dropdown-item href="#" @click.prevent="item.action" v-if="item.action" :key="index">
        {{ $t(item.name) }}
      </b-dropdown-item>
    </template>
    <template v-if="isPicaThirdLevelDomain">
      <b-dropdown-divider></b-dropdown-divider>
      <b-dropdown-item :href="B2BUrl" target="_blank">
        GetPica Business
        <Icon name="linkExternal" width="16" class="ml-1"/>
      </b-dropdown-item>
      <div class="border-bottom-gradient"></div>
    </template>
  </b-dropdown>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {getB2BUrl, metricB2B} from "@/utils";

export default {
  name: "MainMenu",
  computed: {
    ...mapGetters(['isPicaThirdLevelDomain']),
    ...mapGetters('auth', [
      'currentUser'
    ]),
    B2BUrl() {
      return this.getB2BUrl(metricB2B.MENU)
    },
    menuItems() {
      return [
        {name: 'menu.checkins_list', route: 'checkins-list'},
        {name: 'menu.do_checkin', action: () => this.$bvModal.show('bv-modal-checkin-maker')},
        {divider: true},
        {name: 'menu.account', route: 'profile-resume', extra: this.currentUser.email},
        {name: 'menu.privacy_settings', route: 'profile-privacy'},
        {name: 'menu.password_change', route: 'profile-change-password'},
        {name: 'menu.logout', action: () => this.onLogout()},
      ]
    }

  },
  methods: {
    getB2BUrl,
    ...mapActions('auth', ['logout']),

    async onLogout() {
      await this.logout()
      await this.$router.push('/')
    }
  }
}
</script>


<style scoped>

</style>